import React, { useEffect, useState } from 'react'
import IntraBankTransfersPage from '../../../IntraBankTransfers'
import { useSelector } from 'react-redux';
import { intraBankTxn } from '../../../../../api/commonApis';
import { intraBankTransfer } from '../../../../../utils/JsonData/Interbank transfers 1';

const IntraBankTransfers = () => {
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
  console.log("Abdul API CALL INTRABANK",selectedAccountId);
  const [intra, setIntra] = useState([]);

  useEffect(() => {

      const fetchData = async () => {
        console.log("Abdul API CALL INTRABANK",selectedAccountId);
        try {
          let aggregate = selectedAccountId !== 'all'? false : true;
          let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
          
          const response = await intraBankTxn(account_id, aggregate);
  
  
          if(Object.keys(response).length > 0){
              setIntra(response)
          } else{
              setIntra(intraBankTransfer)
          }
  
        } catch (error) {
  
          console.log("ERROR", error);
        }
      }
  
      if (selectedAccountId) fetchData();
    }, [selectedAccountId, reportDetails]);
  
  return (
    <IntraBankTransfersPage />
  )
}

export default IntraBankTransfers